import { useContext, useEffect, Suspense, lazy } from "react";
import { Routes, Route, useNavigate } from 'react-router-dom';
import { LanguageContext, UserContext } from '../contexts';
import { pages } from '../config'
import { consumeReturnTo } from '../utils/helpers';
import { useLabels, showForProduct } from '../hooks';

import Home from '../pages/Home';
import Purchase from '../pages/Purchase';
import NotFound from '../pages/NotFound';
import Dynamic from '../pages/Dynamic';
import User from '../pages/User';
import PersonalInformation  from '../pages/PersonalInformation';
import ChangePassword  from '../pages/ChangePassword';
import Search from '../pages/Search';
import Crossword from '../pages/Crossword';
import Nakdan from '../pages/nakdan/index';
import Transcription from '../pages/Transcription/index'
import Waiting from '../pages/Waiting/index'

const PostLoginRedirect = () => {
    const navigate = useNavigate();
    const { listProducts } = useContext(UserContext);
    const { getLocalUrlByLanguage } = useLabels();
    let hasReturnTo = false;
    try { hasReturnTo = !!sessionStorage.getItem('returnToAfterLogin'); } catch (_) {}
    // Nakdan-only subscribers land on the Nakdan page instead of word search
    const isNakdanOnly = !!listProducts?.some(product => product.name === showForProduct.Nakdan)
        && !listProducts.some(product => product.name === showForProduct.RavMilim);
    useEffect(() => {
        if (hasReturnTo) {
            const returnTo = consumeReturnTo();
            if (returnTo) navigate(returnTo, { replace: true });
        } else if (isNakdanOnly) {
            navigate(getLocalUrlByLanguage('/nakdan'), { replace: true });
        }
    }, [navigate, hasReturnTo, isNakdanOnly, getLocalUrlByLanguage]);
    if (hasReturnTo || isNakdanOnly) return null;
    return <Search />;
};

/*
const NotFound = lazy(() => import('../pages/NotFound'));
const Search = lazy(() => import('../pages/Search'));
const Crossword = lazy(() => import('../pages/Crossword'));
*/

function AppRouter() {
    const { language } = useContext(LanguageContext);
    const { hasPermissions } = useContext(UserContext);
    const migrationInProgress = (() => {
        try { return sessionStorage.getItem('migrationInProgress') === '1'; } catch (e) { return false; }
    })();

    return (
        <Suspense>
            <Routes>
                {
                    [
                        "about",
                        "numbers",
                        "help",
                        "contact_us",
                        "license",
                        "editors_note",
                        "cancellation",
                        "privacy_policy",
                    ].map(pageKey => <Route key={`page_key--${pageKey}`} path={`/${pageKey}`} Component={() => <Dynamic pageKey={pageKey} {...pages[language][pageKey]} />} />)
                }
                <Route path="/crossword/:word?"  Component={Crossword} />
                <Route path="/search/:searchStr?/:wordEntry?/:wordId?"  Component={Search} />
                <Route path="/purchase/:subscriptionName?"  Component={Purchase} />
                <Route path="/user"  Component={User} />
                <Route path="/personal_information"  Component={PersonalInformation} />
                <Route path="/nakdan"  Component={Nakdan} />
                <Route path="/transcription"  Component={Transcription} />
                <Route path="/change_password"  Component={ChangePassword} />
                <Route path="/purchase/waiting"  Component={Waiting} />
                <Route path="/login?"  Component={(!migrationInProgress && hasPermissions) ? PostLoginRedirect : Home} />
                <Route path="*" Component={NotFound} />
                
            </Routes>
        </Suspense>
    );
};

export default AppRouter;